import Clients from "./clients";

const middlewares = [
    Clients,
    //
];

export default middlewares;